import React from "react";

import { Button, Flex, Row } from "antd";
import { useHistory } from "react-router-dom";

import { hasPermission, permissions } from "../../../../utils/Permissions";

import "./LandingPage.css";

export default function LandingPage({
  heading, description, image, setDisplayForm,
}) {
  const canOnboardNewFeature = hasPermission([
    permissions.onboarding.onboardProduct,
    permissions.onboarding.onboardEnvironment,
  ]);
  const history = useHistory();

  return (
    <Row justify="center" className="LandingPage__Div" span={24}>
      <Flex className="LandingPage">
        <div className="LandingPage__Container">
          <p className="LandingPage__Text">Begin your</p>
          <p className="LandingPage__Heading">
            {heading}
          </p>
          <p className="LandingPage__Description">
            {description}
          </p>
          {canOnboardNewFeature ? (
            <Button
              type="primary"
              className="LandingPage__Btn"
              size="large"
              onClick={() => setDisplayForm(true)}
            >
              Get started
            </Button>
          ) : (
            <>
              <p className="LandingPage__RequestText">Request your administer</p>
              <Button
                type="default"
                className="LandingPage__Btn"
                size="large"
                onClick={() => history.push("/sample-submission")}
              >
                Back
              </Button>
            </>
          )}
        </div>
        <div className="LandingPage__Image">
          <img src={image} alt="" />
        </div>
      </Flex>
    </Row>
  );
}
